<h1 class="page-title">Contact</h1>
<div class="contact-container">
  <app-card title="Have a Question or Feedback? Let Us Know!">
    <p>
      We appreciate you taking the time to share your thoughts with us.
      <br />Every action counts in making the world a better place!
    </p>
    <div class="contact-data">
      <div class="contact-item">
        <app-icon name="user" class="contact-icon" color="#000"></app-icon>
        <span>Manuel Fischer</span>
      </div>
      <div class="contact-item">
        <app-icon name="map_pin" class="contact-icon" color="#000"></app-icon>
        <div class="address">
          <span
            >Bern University of Applied Sciences – Department of Business</span
          >
          <span>Sustainable Development</span>
          <span>Falkenstrasse 16</span>
          <span>3005 Bern, Schweiz</span>
        </div>
      </div>
      <div class="contact-item">
        <app-icon name="mail" class="contact-icon" color="#000"></app-icon>
        <span
          ><a href="mailto:sustainability@bfh.ch"
            >sustainability&#64;bfh.ch</a
          ></span
        >
      </div>
    </div>
  </app-card>
</div>
